import { Form, Input, Modal } from "antd"
import React from "react"

const normalizeHttpsUrl = ( url ) => {
	if ( !url ) {
		return url
	}
	return url.startsWith( "http" )
		? url
		: `https://${url.replace( /^https?:\/\//, "" )}`
}
const isValidUrl = ( value ) => {
	try {
		const url = new URL( normalizeHttpsUrl( value ) )
		if ( url.protocol !== "https:" ) {
			return false
		}
		return url.protocol === "https:" && url.hostname.includes( "." )
	} catch {
		return false
	}
}

export const AnalyzeUrlModal = ( {
	open,
	onCancel,
	onUrlSubmit,
} ) => {
	const [ form ] = Form.useForm()

	return (
		<Modal
			getContainer={ false }
			centered
			open={ open }
			title={ "Analyze URL" }
			width={ 850 }
			okText={ "Analyze" }
			cancelText={ "Cancel" }
			onCancel={ () => {
				form.resetFields()
				onCancel()
			} }
			onOk={ () => {
				form.validateFields().then( ( values ) => {
					onUrlSubmit( normalizeHttpsUrl( values.url ) )
					form.resetFields()
				} )
			} }
		>
			<Form
				preserve
				form={ form }
				layout={ "horizontal" }
				wrapperCol={ { span: 24 } }
				labelWrap
				colon={ false }
				className={ "content-scroll" }
			>
				<Form.Item
					name={ "url" }
					rules={ [
						{ required: true, message: "Please enter the URL" },
						{
							validator: ( _, value ) => {
								if ( !value || isValidUrl( value ) ) {
									return Promise.resolve()
								}
								return Promise.reject( new Error( "Please enter a valid URL" ) )
							},
						},
					] }
				>
					<Input
						placeholder={ "Enter URL here" }
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
